(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-size-chart-open]');
    if (openTrigger) {
      var modal = document.getElementById(openTrigger.getAttribute('data-modal-target'));
      if (modal && typeof modal.showModal === 'function') modal.showModal();
      return;
    }

    var closeTrigger = event.target.closest('[data-size-chart-close]');
    if (closeTrigger) {
      var modal = closeTrigger.closest('dialog.size-chart-modal');
      if (modal) modal.close();
      return;
    }

    // Click on the backdrop (the <dialog> element itself, outside the panel) closes it.
    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('size-chart-modal')) {
      event.target.close();
      return;
    }

    var tabButton = event.target.closest('[data-size-chart-tab]');
    if (tabButton) {
      var modal = tabButton.closest('.size-chart-modal');
      var key = tabButton.getAttribute('data-size-chart-tab');

      modal.querySelectorAll('[data-size-chart-tab]').forEach(function (btn) {
        var active = btn === tabButton;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      modal.querySelectorAll('[data-size-chart-panel]').forEach(function (panel) {
        var active = panel.getAttribute('data-size-chart-panel') === key;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
